import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CreateUserService } from "./create-user/create-user.service";
import { DashboardService } from "./dashboard/dashboard.service";
import { PriceService } from "./dashboard/price/price.service";
import {PaypalForAppComponent} from './paypal-for-app/paypal-for-app.component';

const routes: Routes = [
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "create-user",
    loadChildren: () =>
      import("./create-user/create-user.module").then(
        (m) => m.CreateUserModule
      ),
    resolve: [CreateUserService],
  },
  {
    path: "DY1jFI765pz92Tr7OZphOvkDEldyygZO",
    component: PaypalForAppComponent
  },
  {
    path: "247eTdOJWxFtMRNunNJgx1nrKxd6HHsS",
    component: PaypalForAppComponent
  },
  {
    path: "",
    loadChildren: () =>
      import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
    resolve: [DashboardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
